<template>
  <a-modal :title="form.goods_id ? '修改项目信息' : '新增项目信息'" :visible="visible" :confirm-loading="confirmLoading"
    @ok="handleOk" @cancel="handleCancel" destroyOnClose :maskClosable="false" width="1200px">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-row>
        <a-col :span="24">
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="项目名称" prop="goods_name">
                <a-input v-model="form.goods_name" placeholder="请输入项目名称" />
              </a-form-model-item>
              <a-form-model-item label="项目成本价" prop="goods_cost">
                <a-input-number v-model="form.goods_cost" :min="0" :step="0.01" style="width: 100%"
                  placeholder="请输入项目成本价" />
              </a-form-model-item>
              <a-form-model-item label="一级分类" prop="categorize_id">
                <!-- <a-cascader
              v-model="form.categorize_id"
              :options="supplierList"
              placeholder="所属供应商一级分类"
              expand-trigger="hover"
              :fieldNames="{
                label: 'label',
                value: 'value',
                children: 'categorize',
              }"
            /> -->
                <el-cascader style="width: 100%" v-model="form.categorize_id" :options="supplierList"
                  :show-all-levels="true" :props="{
                    children: 'categorize'
                  }" filterable></el-cascader>
              </a-form-model-item>
              <a-form-model-item label="项目售价" prop="goods_price">
                <a-input-number v-model="form.goods_price" :min="0" :step="0.01" style="width: 100%"
                  placeholder="请输入项目售价" />
              </a-form-model-item>
              <a-form-model-item label="项目单位" prop="unit">
                <a-input v-model="form.unit" placeholder="请输入项目单位，如:元/次" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="项目主图" prop="goods_img">
                <a-upload name="file" list-type="picture-card" :multiple="false" :action="baseURL + '/admin/sys/upload'"
                  :remove="remove" @change="handleChange" @preview="preview" :show-upload-list="false" :headers="{
                    Authorization: `Bearer ${token}`,
                  }">
                  <img v-if="form.goods_img" :src="form.goods_img" alt="avatar" width="100px" />
                  <div v-else>
                    <a-icon :type="loading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">Upload</div>
                  </div>
                  <div class="ant-upload-text" v-if="!!form.goods_img" @click.stop="remove()">点击删除</div>
                </a-upload>
                <span style="font-size: 14px;color: #888;margin-top: -40px;">提示：小程序中, 此图片会作为项目主图展示</span>
              </a-form-model-item>
              <a-form-model-item label="项目备注" prop="remark">
                <a-input v-model="form.remark" placeholder="请输入项目备注，如:需满16周岁" />
              </a-form-model-item>

            </a-col>
          </a-row>
        </a-col>
        <a-col :span="24">
          <a-alert message="以下是小程序板块管理的内容" description="" type="info" show-icon></a-alert>
          <br>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="小程序项目名称" prop="goods_appname">
                <a-input v-model="form.goods_appname" placeholder="小程序端展示的项目名称" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="小程序项目价格" prop="goods_appprice">
                <a-input v-model="form.goods_appprice" placeholder="小程序端展示的项目价格(XX元或价格区间)" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="项目副标题" prop="subtitle">
                <a-textarea placeholder="小程序展示项目的副标题描述" :rows="2" v-model:value="form.subtitle"></a-textarea>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="侧边栏所属" prop="is_app">
                <a-select show-search v-model="form.navid" placeholder="请选择" option-filter-prop="children"
                  :filter-option="filterOption">
                  <a-select-option :value="v.navid" v-for="v in navList" :key="v.navid">
                    {{ v.title }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label-col="{ span: 3 }" label="轮播图" prop="is_app">
                <MyUpload v-model="form.lunbo"></MyUpload>
                <span>提示：建议上传横向展示的图片(如16:9)</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="当前状态" prop="is_app" required>
                <a-radio-group v-model="form.is_app">
                  <a-radio value="1">立即上架</a-radio>
                  <a-radio value="2">立即下架</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="排序">
                <a-input-number v-model="form.goods_sort" :min="0" :max="999999999" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-col :span="24">
            <p>小程序展示项目简介内容：</p>
            <div style="border: 1px solid #ccc;">
              <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig"
                :mode="mode" />
              <!-- {{ form.html }} -->
              <Editor style="height: 500px; overflow-y: hidden;" v-model="form.html" :defaultConfig="editorConfig"
                :mode="mode" @onCreated="onCreated" />
            </div>
          </a-col>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import http from '@/api/index'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { baseURL } from "@/api/index";
import { mapState } from "vuex";
import "element-ui/lib/theme-chalk/index.css";
import MyUpload from '@/components/MyUpload/index.vue'
export default {
  computed: {
    ...mapState(["token"]),
  },
  components: { Editor, Toolbar, MyUpload },
  data() {
    return {
      editor: null,
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            async customUpload(file, insertFn) {
              try {
                const formData = new FormData();
                formData.append('file', file);
                const res = await http({
                  url: '/admin/sys/upload',
                  method: 'post',
                  headers: {
                    'Content-Type': 'multipart/form-data', // 告诉服务器上传的是文件
                  },
                  data: formData
                })
                debugger
                // 插入上传的图片url，alt，herf
                insertFn(res.data.url, 'image', res.data.url)
                // data.forEach(item => {
                //   insertFn(item, 'image', item)
                // })
              } catch (error) {
                console.log(error);
              }
            }
          }
        }
      },
      mode: 'default', // or 'simple'
      baseURL,
      visible: false,
      confirmLoading: false,
      loading: false,
      fileList: [],
      form: {
        goods_id: "",
        categorize_id: undefined,
        goods_name: "",
        goods_img: "",
        goods_cost: "",
        goods_price: "",
        unit: "",
        remark: "",
        html: '',
        is_app: "2",
        navid: undefined,
        subtitle: '',
        lunbo: [],
        goods_appname: "",
        goods_appprice: "",
        goods_sort: 0,
      },
      treeData: [],
      groupList: [],
      loadingGroup: false,
      rules: {
        goods_name: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
        ],
        goods_cost: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
        ],
        goods_price: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
        ],
        categorize_id: [
          {
            required: true,
            message: "请选择供应商",
            trigger: "change",
          },
        ],
      },
      labelCol: { span: 7 },
      wrapperCol: { span: 16 },
      supplierList: [],
      navList: []
    };
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    init(id) {
      this.visible = true;
      this.form.goods_id = id;
      this.getSupplierList();
      this.getNavList();
      if (id) {
        this.$http({
          url: "/admin/suppliergoods/info",
          method: "post",
          data: {
            id: id,
          },
        }).then((res) => {
          this.form = {
            ...res.data,
            navid: res.data.navid || undefined,
            html: res.data.html || "",
            lunbo: res.data.lunbo ? res.data.lunbo.split(",") : [],
          };
        });
      }
    },
    getNavList() {
      this.$http({
        url: "/admin/appnav/page?page=1&limit=200&state=1",
        method: "get",
      }).then((res) => {
        this.navList = res.data.result;
      });
    },
    getSupplierList() {
      this.$http({
        url: "/admin/supplier/page?page=1&limit=200",
        method: "get",
      }).then((res) => {
        this.supplierList = res.data.result;
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: this.form.goods_id
              ? "/admin/suppliergoods/update"
              : "/admin/suppliergoods/create",
            method: "post",
            data: {
              ...this.form,
              lunbo: this.form.lunbo.join(","),
            },
          })
            .then(() => {
              this.$message.success(
                this.form.goods_id ? "修改成功" : "创建成功"
              );
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
    remove(e) {
      this.form.goods_img = "";
    },
    handleChange(info) {
      // let fileList = [...info.fileList];
      // fileList = fileList.slice(-1);
      // fileList = fileList.map((file) => {
      //   if (file.response) {
      //     file.url = file.response.data.url;
      //     this.form.department_logo = file.response.data.url;
      //   }
      //   return file;
      // });
      // this.fileList = fileList;
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status === "done") {
        // Get this url from response in real world.
        // getBase64(info.file.originFileObj, (imageUrl) => {
        //   this.form.goods_img = imageUrl;
        //   this.loading = false;
        // });
        this.loading = false;
        this.form.goods_img = info.file.response.data.url;
      }
    },
    preview(e) {
      this.$viewerApi({
        images: [e.response.url],
      });
    },
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style>
.avatar-uploader>.ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>